import React, { useState } from 'react';
import { Card, Button, InputNumber, Space, Select, Input, DatePicker, Typography } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useMovimientos } from '../../context/movimientosContext';

const { Text } = Typography;
const { Option } = Select;

export const ArticuloPosiciones = ({ articulo }) => {
  const [selectedPosicion, setSelectedPosicion] = useState({ letra: null, num1: null, num2: null });
  const [cantidad, setCantidad] = useState(0);
  const [lote, setLote] = useState('');
  const [fechaVencimiento, setFechaVencimiento] = useState(null);

  const { addPosicionToArticulo, removeArticuloMovimiento } = useMovimientos();

  const generatePosString = () =>
    `${selectedPosicion.letra}-${selectedPosicion.num1}-${selectedPosicion.num2}`;

  const handleAdd = () => {
    const pos = generatePosString();
    const fv = fechaVencimiento ? dayjs(fechaVencimiento).format('YYYY-MM-DD') : null;

    addPosicionToArticulo(articulo._id, pos, cantidad, {
      lote: (lote || '').trim() || null,
      fechaVencimiento: fv
    });

    setSelectedPosicion({ letra: null, num1: null, num2: null });
    setCantidad(0);
    setLote('');
    setFechaVencimiento(null);
  };

  return (
    <Card
      title={articulo.nombre}
      style={{ marginTop: 12 }}
      extra={
        <Button type="text" danger icon={<DeleteOutlined />} onClick={() => removeArticuloMovimiento(articulo._id)} />
      }
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Space wrap>
          <Select
            value={selectedPosicion.letra}
            placeholder="Letra"
            onChange={v => setSelectedPosicion(p => ({ ...p, letra: v }))}
            style={{ width: 90 }}
          >
            {Array.from({ length: 26 }, (_, i) => {
              const ch = String.fromCharCode(65 + i);
              return <Option key={ch} value={ch}>{ch}</Option>;
            })}
          </Select>
          <Select
            value={selectedPosicion.num1}
            placeholder="1-20"
            onChange={v => setSelectedPosicion(p => ({ ...p, num1: v }))}
            style={{ width: 90 }}
          >
            {Array.from({ length: 20 }, (_, i) => <Option key={i + 1} value={i + 1}>{i + 1}</Option>)}
          </Select>
          <Select
            value={selectedPosicion.num2}
            placeholder="1-20"
            onChange={v => setSelectedPosicion(p => ({ ...p, num2: v }))}
            style={{ width: 90 }}
          >
            {Array.from({ length: 20 }, (_, i) => <Option key={i + 1} value={i + 1}>{i + 1}</Option>)}
          </Select>

          <InputNumber 
            min={0} 
            step={0.01}
            precision={2}
            value={cantidad} 
            onChange={setCantidad} 
            placeholder="Cantidad" 
            style={{ width: 120 }} 
          />
          <Input placeholder="N° de lote (opcional)" value={lote} onChange={e => setLote(e.target.value)} style={{ width: 180 }} />
          <DatePicker
            placeholder="Vencimiento (opcional)"
            value={fechaVencimiento ? dayjs(fechaVencimiento) : null}
            onChange={setFechaVencimiento}
            format="YYYY-MM-DD"
            style={{ width: 180 }}
          />

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAdd}
            disabled={!selectedPosicion.letra || !selectedPosicion.num1 || !selectedPosicion.num2 || !cantidad}
          >
            Agregar Posición
          </Button>
        </Space>

        <Text type="secondary">Lote y vencimiento son opcionales. Si repetís misma combinación, suma cantidades.</Text>
      </Space>
    </Card>
  );
};

export default ArticuloPosiciones;